import { render, staticRenderFns } from "./LeaglTenderSet.vue?vue&type=template&id=4f12e256&scoped=true&"
import script from "./LeaglTenderSet.vue?vue&type=script&lang=js&"
export * from "./LeaglTenderSet.vue?vue&type=script&lang=js&"
import style0 from "./LeaglTenderSet.vue?vue&type=style&index=0&id=4f12e256&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f12e256",
  null
  
)

export default component.exports